export default {
  header: {
    product: "Products",
    subproduct: [
      {
        name: "products",
        item: [
          {
            name: "",
            item: [
              {
                name: "CheckID FacialSense Bio Attendance",
              },
              {
                name: "CheckID FacialSense Visitor management",
              },
            ],
          },
        ],
      },
    ],
    industries: "Industries",
    subindustries: [
      {
        name: "CHECKID FACIALSENSE BIO ATTENDANCE",
        item: [
          {
            name: "",
            item: [
              {
                name: "Office Employee",
              },
              {
                name: "Retail Workforce",
              },
              {
                name: "Mobile and Remote Employee",
              },
              {
                name: "Student Attendance",
              },
              {
                name: "Construction Site",
              },
              {
                name: "Healthcare",
              },
              {
                name: "Service and Hospitality",
              },
              {
                name: "Factory and Warehouse",
              },
              {
                name: "Agriculture",
              },
            ],
          },
        ],
      },
      {
        name: "CHECKID FACIALSENSE VISITOR MANAGEMENT",
        item: [
          {
            name: "",
            item: [
              {
                name: "Organization",
              },
              {
                name: "Travel and Excursion",
              },
              {
                name: "Banking or financial institutes",
              },
              {
                name: "Hotels and restaurants",
              },
              {
                name: "Consultation services",
              },
              {
                name: "Building and apartments",
              },
              {
                name: "Customer support",
              },
              {
                name: "Entertainment",
              },
              {
                name: "Schools and campuses",
              },
            ],
          },
        ],
      },
    ],
    pricing: "Pricing",
    subpricing: [
      {
        name: "pricing",
        item: [
          {
            name: "",
            item: [
              {
                name: "CheckID FacialSense Bio Attendance",
              },
              {
                name: "CheckID FacialSense Visitor management",
              },
            ],
          },
        ],
      },
    ],
    resources: "Resources",
    subresources: [
      {
        name: "product",
        item: [
          {
            name: "CHECKID FACIALSENSE BIO ATTENDANCE",
            item: [
              {
                name: "On-premise Server",
              },
              {
                name: "Standard clients",
              },
              {
                name: "Lite Clients",
              },
            ],
          },
          {
            name: "CHECKID FACIALSENSE VISITOR MANAGEMENT",
            item: [
              {
                name: "On-premise Server",
              },
              {
                name: "Visitor Clients",
              },
              {
                name: "Visitor Lite Clients",
              },
            ],
          },
          {
            name: "OTHER",
            item: [
              {
                name: "CheckID FacialSense Surveillance Client",
              },
              {
                name: "CheckID FacialSense Guard",
              },
              {
                name: "Scanner Drivers",
              },
              {
                name: "Developer samples",
              },
              {
                name: "Previous versions",
              },
            ],
          },
        ],
      },
      {
        name: "DOCUMENTATION",
        item: [
          {
            name: "USER GUIDE",
            item: [
              {
                name: "CheckID FacialSense Bio Attendance",
              },
              {
                name: "CheckID FacialSense Visitor Management",
              },
              {
                name: "Developer guide",
              },
            ],
          },

          {
            name: "OTHER",
            item: [
              {
                name: "Payroll integration",
              },
              {
                name: "Attendance reports",
              },
              {
                name: "Third-party integrations",
              },
              {
                name: "Supported devices",
              },
            ],
          },
        ],
      },
      {
        name: "QUICK START GUIDE",
        item: [
          {
            name: "CHECKID FACIALSENSE BIO ATTENDANCE",
            item: [
              {
                name: "Cloud",
              },
              {
                name: "On-premises",
              },
            ],
          },

          {
            name: "CHECKID FACIALSENSE VISITOR MANAGEMENT",
            item: [
              {
                name: "Cloud",
              },
              {
                name: "On-premises",
              },
            ],
          },
        ],
      },
    ],
    company: "Company",
    subcompany: [
      {
        name: "Company",
        item: [
          {
            name: "",
            item: [
              {
                name: "About us",
              },
              {
                name: "Contact us",
              },
              {
                name: "Customer references",
              },
              {
                name: "Register as a distributor",
              },
              {
                name: "News and updates",
              },
              {
                name: "Blog",
              },
            ],
          },
        ],
      },
    ],
    login: "Login",
    signup: "Sign Up",
  },
  homepage: {
    solution: {
      header: "Biometric employee attendance and visitor management solutions",
      description:
        "Simple to use and easy to integrate, CheckID FacialSense multi-biometric solutions offer fast and secure employee and visitor time management.",
      get: "Get started for free now!",
      request: "Request demo",
      janedoe: "Jane Doe",
      employee: "Employee",
      checkin: "Check in",
      day1: "Friday, August 12, 2022",
      visitor: "Visitor",
      welcome: "Welcome",
      totalhours: "Total hours",
      workhours: "Work hours",
      vacation: "Vacation",
    },
    product: {
      our: "Our",
      products: "products",
      header: " Biometric Attendance Management System",
      description:
        " CheckID FacialSense BioAttendance is a Biometric Attendance Management System designed to register and manage employee using face, fingerprint, and iris biometric identification.",
      features: {
        header: "Powerful features:",
        feature1: "Face, Fingerprint, and Iris attendance recognition",
        feature2: "Geofencing and location based tracking",
        feature3: "Contactless and hygienic",
        feature4: "Identification with face mask",
        feature5: " Face liveness detection",
        feature6: "Real-time face detection",
        feature7: "Fraudulent prevention",
        feature8: "Multiple face detection",
        feature9: "Advanced reporting",
      },
      learnmore: "Learn more",
    },
    visitor: {
      header: " Biometric Visitor Management System",
      description:
        "CheckID FacialSense Biometric Visitor Management is designed to register, monitor, and manage visitors, their appointments, attendance & access control of any organization or institute by using face, fingerprint, and iris biometric identification.",
      description1:
        " It can be used to manage any type of visitor, such as customers, guests, attendees, suppliers, and passengers.",
      features: {
        header: "Powerful features:",
        feature1: "Secure visitor identification",
        feature2: "Real-time visitor analytics",
        feature3: "Online visitor appointments",
        feature4: "Visitor registration kiosk",
        feature5: "Visitor access control",
        feature6: "Visit logs",
        feature7: "Visitor information kiosk",
        feature8: "Real-time notifications",
        feature9: "Advanced scheduling",
        feature10: "Automatic appointment time and visitor queue management",
      },
      learnmore: "Learn more",
      johnsmith: "John Smith",
      checkid: "CheckID FacialSense VMS",
      now: "now",
      des: "This is a reminder that you have an appointment scheduled for tomorrow at 10 am.",
    },
    benefit: {
      header: {
        bio: "Biometric system",
        benefit: "benefits",
      },
      items: {
        0: {
          header: "For the institution",
          context: [
            {
              label: "Face biometric",
              text: "attendance with integrated camera. No proprietary hardware is required.",
            },
            {
              label: "High accuracy and security",
              text: "biometric identification with face, fingerprint, or iris provides highly accurate and reliable identification.",
            },
            {
              label: "No Legacy cards or badges",
              text: "biometric identification prevents fake attendance attempts on behalf of others.",
            },
            {
              label: "Passive visitor identification",
              text: "high volume attendance monitoring with multiple face recognition at once by surveillance cameras.",
            },
          ],
        },
        1: {
          header: "For the employee",
          context: [
            {
              label: "Easy to Use",
              text: "never worry about a lost or forgotten card or badge. Use biometrics to record attendance.",
            },
            {
              label: "Accurate",
              text: "recording biometrics for attendance ensures your attendance is accurately monitored.",
            },
            {
              label: "Anytime, Anywhere",
              text: "log your attendance wherever you are, using a personal smartphone.",
            },
            {
              label: "Contactless attendance recording",
              text: "no-contact face and iris biometric scanning offers a more hygienic attending experience.",
            },
            {
              label: "Off-line time tracking",
              text: "CheckID FacialSense records your attendance in real-time with no connectivity and sync as soon as the connectivity is available.",
            },
          ],
        },
        2: {
          header: "For the visitor",
          context: [
            {
              label: "Convenient",
              text: "easy to make appointments from anywhere, at anytime.",
            },
            {
              label: "Alerts",
              text: "the system will remind you about the appointments, in case you forgot them.",
            },
            {
              label: "Contactless check-in",
              text: "visitor face or iris scanning offers a more hygienic attendance recording solution.",
            },
            {
              label: "Privacy",
              text: "face, fingerprint, or iris biometric visitor validation ensures access to your information with only your authorization.",
            },
            {
              label: "Personalized experience",
              text: "visitors get personalized information by using biometric recognition.",
            },
          ],
        },
      },
    },
    testimonials: {
      header: "Testimonials",
      items: [
        {
          description:
            "“CheckID FacialSense offers a complete solution to monitor and control the work of your employees in offices, educational and healthcare institutions, hotels and factories. With the help of multimedia scanning, you can minimize the risk of third-party intrusion into the company.”",
          name: "Alex Bern",
          position: "Manager of the partnership department at Fixthephoto.com",
        },
        {
          description:
            "“We are using this software for different locations and this is just work fines so far. I wish there are some more features, but ok for small and medium size organizations.”",
          name: "Rajeev S.",
          position: "CFO",
        },
        {
          description:
            "“We are using this software in our school for taking attendance of staff and found very useful. This software register all our staff’s detail and biometrics information quickly and we immediately started taking the attendance of our staff. We have been able track the absentee of our staff and late comers. We have been able to take the attendance report on daily basis very quickly without any trouble.”",
          name: "Seema C.",
          position: "Teacher, Red Roses Public School",
        },
        {
          description:
            "“Before we use traditional time and attendance I have to do lot of work to synchronize reports. But with CheckID FacialSense we do it with just few clicks.”",
          name: "Priya P.",
          position: "Smartcard IT India",
        },
        {
          description:
            "“Face recognition works well with normal camera also. Very convenient and cost effective and value for money. Highly accurate. The system has face, finger and iris biometrics support.”",
          name: "Rakesh B.",
          position: "Manager - Sales & Marketing, BioScan Solution",
        },
        {
          description:
            "“This is the perfect software for anyone / company that has any information that needs to be kept confidential. Everything is up to date whats not to like. Hands down the best software for anything that you hold in high regard.”",
          name: "Marcus D.",
          position: "Information Technology, Ogle School",
        },
        {
          description:
            "“Accuracy in identifying the face and fingerprint. Also Iris recognition. Mobile face recognition with multiple face detection.”",
          name: "Rakesh B.",
          position: "Head - Marketing, BioScan Solution",
        },
        {
          description:
            "“We are using this product for attendance purpose, it is designed in such a way that anyone can easily setup this for their organization. We are using Face recognition for authentication. Mobile app is also very useful for field force executives. It allows us to easily capture all our on-field executives, which help seamless payroll processing based on this data.”",
          name: "Kishan G.",
          position:
            "Information Technology and Services, Innova Systems (India) Pvt. Ltd.",
        },
        {
          description:
            "“CheckID FacialSense Biometric Time & attendance solution is excellent to support on windows & android both platforms. Single solution for all biometric based needs. Need to optimize on the cost part as per required biometric for T&A.”",
          name: "Piyush K.",
          position: "CEO, Biotechnology, Saral Infotech",
        },
        {
          description:
            "“Very fine app with better functionalities than other apps. Needs some minor enhancements and fixes.”",
          name: "Shiv Kumar S.",
          position: "Computer & Network Security",
        },
        {
          description:
            "“CheckID FacialSense bio attendance can revolutionize your employee attendance software for its features, very easy to use and update and to teach to employees. It needs a little improvement on the manual, color on the interface and needs more customizable menus when programming attendance.”",
          name: "Mary Ann R.",
          position: "Executive Assistant, LGU Reina Mercedes",
        },
      ],
    },
    question: {
      header: {
        frequently: "Frequently",
        asked: "asked questions",
      },
      description:
        " Everything you need to know about the product and billing.",
      items: [
        {
          header: "Why we need to Biometric visitor identification",
          body: "Biometric identification is simply to make sure that the actual person is present. All other legacy systems either do not have person identification or have a high possibility to impersonate. Loss of such fraudulent attempt may be much bigger than the lost on wages.",
        },
        {
          header:
            "Why we need to select CheckID FacialSense biometric attendance?",
          body: "Biometric identification in employee or visitor attendance need to have a guarantee on true identification. CheckID FacialSense uses biometric identification technology algorithms developed by Mobile-ID. CheckID FacialSense supports face, fingerprint and iris biometric recognition. All modality support is an advantage to use in any security requirement and environment. There are many other advantages combined with biometric recognition such as face mask, safety hat, glasses, age, gender etc. recognition and enforcing.",
        },
        {
          header: "Do we get free support for CheckID FacialSense products ?",
          body: "CheckID FacialSense product support team provides free online, email and phone. If you need priority support with your support level requirement you can get 24X7 paid priority support.",
        },
        {
          header:
            "Can we get a customized version CheckID FacialSense product?",
          body: "CheckID FacialSense products are highly configurable and can be configure for many of your custom requirements such as change in person detail entry, additional column in reports, change in calculation of a report field etc. CheckID FacialSense can also extend for your custom requirements by using extension module. CheckID FacialSense extension modules extend the product for your requirement without compromising product update capability.",
        },
        {
          header: "Do you have reseller program?",
          body: "We have distributors, resellers and integrators in many countries. If you wan to find any of them, please contact us. If you want to become a reseller, integrator or distributor please contact us",
        },
      ],
    },
    faq: {
      header: "Still have questions?",
      description: "Contact us now for any inquiries - we are here for you.",
      contact: "Contact us",
    },
  },
  products: {
    facialsensevisitormanagement: {
      titlepage:
        "CheckID FacialSense Biometric Visitor Management System | CheckID FacialSense Service",
      solution: {
        header: "CheckID FacialSense Biometric Visitor Management System",
        description:
          "The accurate and efficient solution to manage appointments and provide access for visitors",
        get: "Try for free",
        request: "Request demo",
        janesmith: "John Smith",
        visitor: "Visitor",
        welcome: "Welcome",
        day: "Friday, August 12, 2022",
        time: "07:55:41 AM",
        checkid: "CheckID FacialSense VMS",
        titlecheckid:
          "This is a reminder that you have an appointment scheduled for tomorrow at 10 am.",
        time1: "now",
      },
      benefits: {
        header: "Biometric Visitor Management System ",
        benefitheader: "Benefits",
        institution: "For the institution",
        titlesecurity: "Security",
        security:
          " - visitors are authenticated before entering the premises, hence only authorized access is ensured.",
        titleappointment: "Appointment booking with no hassle",
        appointment: " - the system automatically manages slots.",
        titleincrease: "Increase efficiency of attendance monitoring",
        increase:
          " - the use of passive identification using surveillance cameras enables large workforces to be monitored with ease.",

        user: "For the user",
        titleconvenience: "Convenience",
        convenience:
          " - easy to make appointments from anywhere and at any time.",
        titleautomatic: "Automatic alerts",
        automatic:
          " - system will remind you about the appointments, in case you forgot about it.",
        titlecontactless: "Contactless check-in ",
        contactless:
          " - multimodal scanning offers a more hygienic solution to get access to the premises.",
      },
      systemserver: {
        header: "Visitor Management System Server",
        checkid: "CheckID FacialSense",
        cloud: "Cloud",
        descriptioncloud:
          "Biometric visitor authentication and management with access control system as a cloud service.",
        monthly: "Monthly subscription",
        subscription: "Subscription price is based on visitor count",
        free: "Free subscription supports up to 5 appointments",
        support: "Support CheckID FacialSense Visitor Management client",
        noneed:
          "No need to worry about server installation and no maintenance needed.",
        signup: "Sign up",

        premises: "On-premises",
        descriptionpremises:
          "Biometric visitor authentication and management system with access control that can be hosted on your own premises.",
        one: "One time purchase",
        nolimitation: "No limitation on appointment count",
        needno: "Need to install the server by your own",
        support1: "Support CheckID FacialSense Visitor Management client",
        customer:
          "Customer has freedom to install and configure the Biometric visitor management system server",
        download: "Download trial",
      },
      quickstartguide: {
        header: "Quick start guide",
        description:
          "Step-by-step guides are provided for you to start with the CheckID FacialSense Biometric Attendance system.",
        cloud: "Cloud",
        onpremises: "On-premises",
      },

      fearures: {
        header: "Visitor Management Systems ",
        featureheader: "Features",
        description:
          "Our experienced and highly skilled team have developed a biometric VMS software that is packed full of unique features to take your businesses visitor management to the next level",
        titlesecure: "Secure visitor access",
        secure:
          "Barcode, RFID, face, fingerprint, and iris recognition provide fast, efficient, and secure access for visitor appointments and interaction with visitors.",
        titlesafe: "Safe and hygienic",
        safe: "Touchless barcode, RFID, facial, and iris recognition technology that provides no-contact visitor identification.",
        titleonline: "Online pre appointments",
        online:
          "Online pre-appointment allows visitors to plan their visit in advance and access hassle-free.",
        titleautomated: "Automated access control",
        automated:
          "Visitor-restricted and allowed gates are controlled with attendance devices.",
        titlerealtime: "Realtime visitor analytics",
        realtime:
          "Visitor attendance devices record instances of access-granted and access-denied information in the system.",
        titleelectronic: "Electronic pass",
        electronic:
          "Automatic pass generation or specified electronic passes such as Barcode, RFID, and vehicle license plate are allowed to use as a guest pass.",
        titledata: "Data privacy",
        data: "Visitor operations are performed by authorized personnel, so visitor and visit information is safeguarded from unauthorized access",
        titlebiometric: "Biometric visitor recognition",
        biometric:
          "Access control and management systems use multi-biometric face, fingerprint, and iris recognition.",
        titlecustomizable: "Customizable visit notes",
        customizable:
          "Customized visit notes with forms and attachments can be used to create detailed visitor logs.",
      },
      applications: {
        header: "Applications and Industries",
        applica: "Applications and",
        insdus: " Industries",
        description:
          "Our Bio Attendance system can be successfully used by various businesses and institutions.",
        organizations: "Organizations",
        travel: "Travel and Excursion",
        hotel: "Hotels and Restaurants",
        consulting: "Consulting Services",
        bank: "Banking",
        building: "Building and Apartments",
        school: "Schools and Campuses",
        customer: "Customer support",
      },

      askedquestions: {
        header: "Frequently asked questions",
        description:
          "Everything you need to know about the product and billing.",
        howi: "Does the Visitor Management System support Cloud?",
        howides: "Yes.",
        howcan: "Can it be deployed on Mobile platform?",
        howcandes:
          "Yes, CheckID FacialSense Visitor Management client for Windows and Android provides the following visitor management functions",
        howcandes1: "Visitor walk in registration kiosk",
        howcandes2: "Visitor biometric attendance and access control",
        howcandes3: "Visitor information display",
        howcandes4: "Visitor assistant ",

        cani: "Can it be pure contact-less system and paper free?",
        canides: " it is pure contactless and paper free. ",
        canides1:
          "Biometric only walk in registration with using face or non touched iris or fingerprint capture devices.",
        canides2:
          "Online registration support to register from visitor own device",
        canides3:
          "Notification email of Visitor pass on QR code o use if required",
        canides4: "Visitor registration with their own RFID Identity card",

        whatare: "Does the system customizable with no or little charges?",
        whataredes:
          "Yes. System is highly configurable for different requirements. Any customer soecific requirements can be added with an extention without compromizing the fututure product update capability.",
        isit: "Does the system scalable?",
        desisit:
          "The CheckID FacialSense Visitor Management system is based on micro services and can be scalled to any volume.",
      },
      still: {
        header: "Still have questions?",
        description: "Contact us now for any inquiries - we are here for you.",
        contact: "Contact us",
      },
    },
    bioattendance: {
      titlepage:
        "CheckID FacialSense Biometric Attendance System | CheckID FacialSense Service",
      intro: {
        header: "CheckID FacialSense biometric attendance system",
        description:
          " Accurate and efficient solution for registration, time management and attendance.",
        button: "Try for free",
      },
      benefits: {
        header: {
          bio: " Biometric Visitor Management System",
          benefit: "Benefits",
        },
        body: [
          {
            title: "For the institution",
            content: [
              {
                title: "Cost Effective",
                content:
                  "no ID cards, badges or other equipment is needed for the system users, they just use biometrics.",
              },
              {
                title: "High accuracy and security",
                content:
                  "identification based on multi modal biometrics facilitates very high accuracy and is reliable for fraud prevention.",
              },
              {
                title: 'No "buddy punching"',
                content:
                  "nobody can do a fake check-in or check-out on behalf of another employee / user / attendee.",
              },
              {
                title: "Useful integrations",
                content:
                  "CheckID FacialSense provides flexible data exporting to a range of popular payroll systems.",
              },
              {
                title: "Increase the efficiency of attendance monitoring",
                content:
                  "the use of passive recognition and identification while using surveillance cameras enables large workforces to be monitored with ease.",
              },
            ],
          },
          {
            title: "For the user",
            content: [
              {
                title: "Easy to Use",
                content: "never worry about forgetting a time card.",
              },
              {
                title: "Accurate",
                content:
                  "by using face, fingerprint or iris recognition it ensures that your attendance is recorded accurately.",
              },
              {
                title: "Anytime, Anywhere",
                content:
                  "record attendance from wherever you are working using your personal smartphone.",
              },
              {
                title: "Contact less attendance",
                content:
                  "multi-modality scanning offers a more hygienic solution to attendance monitoring.",
              },
              {
                title: "Off-line attendance",
                content:
                  "never worry about no connectivity and miss of your wages. CheckID FacialSense Bio Attendance solution records your attendance securely offline.",
              },
            ],
          },
        ],
      },

      clientHeader: " BioAttendance Client",
      client: [
        {
          header: "Cloud",
          title:
            "Biometric employee management and access control system as a cloud service.",

          content: [
            { title: "Monthly subscription" },
            { title: "Subscription price depends on employee count" },
            { title: "Free subscription supports up to 5 users" },
            {
              title:
                "Support CheckID FacialSense Standatd and Lite client apps",
            },
            {
              title:
                "No need to worry about server installation and no maintenance needed.",
            },
          ],
          button: "Sign up",
        },
        {
          header: "On-premises",
          title:
            "Biometric employee management and access control system that can be hosted on your own.",

          content: [
            { title: "One time purchase" },
            { title: "No limitation on employee count" },
            { title: "Need a PC to install server software" },
            {
              title:
                "Support CheckID FacialSense Standatd and Lite client apps",
            },
            {
              title:
                "Customer has the freedom to configure the server as they like",
            },
          ],
          button: "Download trial",
        },
      ],
      serverHeader: "BioAttendance server",
      server: {
        header: {
          parameters: "parameters",
          standard: "CheckID FacialSense Standard",
          lite: "CheckID FacialSense Lite",
        },
        body: [
          {
            parameters: "Biometrics",
            standard: "face, fingerprint, iris",
            lite: "face",
          },
          {
            parameters: "Automatic face detection and capture",
          },
          {
            parameters: "Face liveness detection",
          },
          {
            parameters: "Recognize all persons from group photo",
          },
          {
            parameters: "Geo fence tracking /n (Location restriction)",
          },
          {
            parameters: "GPS location logging",
          },
          {
            parameters: "Offline attendance logging",
          },
          {
            parameters: "Operating system support",
            standard: "Windows, Android",
            lite: "Windows, Android, iOS",
          },
          {
            parameters: "Standalone operation",
          },
          {
            parameters: "Access control",
          },
          {
            parameters: "Kiosk mode",
          },
          {
            parameters: "RFID, Barcode",
          },
          {
            parameters: "Personal device /n (Use of your own device)",
          },
          {
            parameters: "Price",
            standard: "95 EUR / installation",
            lite: "Free",
          },
        ],
      },
      features: {
        header: "Features",
        description:
          "Unique features of our product take time and attendance monitoring to the next level.",
        body: [
          {
            title: "Identification with face mask",
            description:
              "Our biometric attendance system is able to recognize a person even if he/she is wearing a face mask, which ensures safe and hygienic identification.",
          },
          {
            title: "Contactless and hygienic",
            description:
              "No physical contact is needed when person is recognized by face or iris.",
          },
          {
            title: "Contactless and hygienic",
            description:
              "Working time of employees can be easily tracked and calculated even if person works remotely. Users can check-in and check-out simply with their mobile device, tablet or personal computer.",
          },
          {
            title: "Multiple biometrics",
            description:
              "3 biometric modalities are available - face, finger and iris",
          },
          {
            title: "Location tracking",
            description:
              "Reports include a summary of working hours, overtime, vacation, sick leave, and other relevant information all of which can be exported to the payroll system.",
          },
          {
            title: "Comprehensive reporting",
            description:
              "Our attendance system can track the geographical location of a person’s place of check-in / check-out.",
          },
          {
            title: "Liveness detection",
            description:
              "Before starting facial recognition, the system can validate that registration is being attempted by a real person.",
          },
          {
            title: "Real-time face detection",
            description:
              "The system can detect the face of a person passing by without stopping and waiting for the camera to take a picture.",
          },
          {
            title: "Multiple face detection",
            description:
              "Our biometric attendance system can detect and recognize faces of all the people seen in the picture.",
          },
        ],
      },
      applicationIndustries: {
        header: {
          application: "Applications",
          and: "and",
          industries: "Industries",
        },
        description:
          " Our Bio Attendance system can be successfully used by various businesses and institutions.",
        body: [
          {
            title: "Office",
          },
          {
            title: "Factories and Warehouses",
          },
          {
            title: "Mobile Workforce",
          },
          {
            title: "Service and Hospitality",
          },
          {
            title: "Agriculture ",
          },
          {
            title: "Construction Companies",
          },
          {
            title: "Educational Institutions",
          },
          {
            title: "Healthcare Organizations",
          },
          {
            title: "Retail",
          },
          {
            title: "Other Areas",
          },
        ],
      },
      question: [
        {
          header: "How I can try FacialSense Bio Attendance?",
          body: "You can register and use free for unlimited time cloud subscription (up to 5 users) or alternatively download and install the trial version, which is free of charge for 30 days.",
        },
        {
          header: "How can I upgrade my trial version to paid version?",
          body: "For FacialSense Bio Attendance Cloud, just sign in and upgrade your subscription.",
        },
        {
          header: "Can I use the data from trial version in the paid version?",
          body: "Yes, you can continue using the data collected during the trial period.",
        },
        {
          header: "What are the requirements for software and hardware?",
          body: "The system can run on all Windows PCs, Windows tablets and Android devices (for iOS only client application for employees/users is available). A camera is needed to perform face identification. The system supports webcams and built-in cameras. For fingerprint or iris identification, the system requires an external fingerprint reader or iris scanner. Supported devices are listed here . Upon connection, supported scanners and camera devices are detected and configured automatically.",
        },
        {
          header:
            "Is it necessary to have an internet connection to use FacialSense Bio Attendance?",
          body: "On-Premises paid version can run without internet connection. Internet connection is needed for activating the license, for using a trial version and for Cloud version.",
        },
        {
          header:
            "What is the difference between FacialSense Standard, FacialSense Server and FacialSense Lite?",
          items: [
            {
              header: "FacialSense Standard",
              body: " - fully functional time and attendance application with all three available modalities (face, finger, iris).",
            },
            {
              header: "FacialSense Server",
              body: " is suitable for usage on your selected server and performs as central database (includes web for administrator).",
            },
            {
              header: "FacialSense Lite",
              body: " is a simple and free for unlimited time application, which is an addition to paid products. It is suitable only for user identification (check-in/check-out) by face.",
            },
          ],
        },
        {
          header:
            "What happens in case of connectivity failure (if you run FacialSense Bio Attendance on your server)?",
          body: "You can configure devices for running in the offline mode. When the server is disconnected, device can still perform employee identification locally and record the attendance. The attendance terminal software updates the data collected offline as soon as connects with the server again.",
        },
      ],
    },
  },
  industries: {
    biometricoffice: {
      titlepage:
        "Biometric Office Attendance System | CheckID FacialSense Service",
      header: "Biometric Office Attendance System",
      bio: "Biometric Office Attendance",
      sys: "System",
      bio2: "Biometric Office",
      sys2: "Attendance System",
      bio1: "Biometric",
      off1: "Office",
      attend1: "Attendance",
      sys1: "System",
      titletransrom: "Transform",
      transfrom: " Your Office Workplace",
      transfromdes1:
        "The CheckID FacialSense biometric office attendance system is a favorite amongst employers for its ability to maintain and enhance an ",
      effect: "efficient, productive and cost effective ",
      workfor: "workforce, without the need for specialist hardware.",
      transfromdes2: "Our system functions by utilizing the ",
      biomatriciden:
        "biometric identification of face, fingerprint and iris scanning",
      checkid:
        ". CheckID FacialSense biometric office attendance system is a simple turnkey integration into your HR and Payroll operations, ensuring your employees are accurately compensated whilst also removing bottlenecks in your payroll administration.",
      transfromdes3:
        "Whilst the biometric technology offers advanced capabilities, the reporting and ",
      userinf: "user interface is simple, intuitive and customizable",
      around:
        " around your business requirements, allowing you to harness these AI-powered capabilities for your own business.",
      biomatricfeature: "Biometric Office Attendance System Key",
      biomatricfeaturekey: " Features",
      biomatricfeaturedes:
        "Carefully designed and built, this software system has a number of powerful features designed to increase the efficiency and accuracy of employee time and attendance monitoring within your office, including:",
      multiple: "Multiple face detection",
      multipledes:
        "Our biometric office attendance system can detect and recognize faces of all the people seen in the picture, meaning your staff do not have to waste time queuing for the clocking in machine.",
      realtime: "Real-time face detection",
      realtimedes:
        "The system can detect the face of a person passing by without requiring to stop and wait while the camera takes a picture.",
      turnkey: "Turnkey solution",
      turnkeydes:
        "CheckID FacialSense biometric office attendance system requires no specialist hardware*, and easily integrates with the leading payroll providers to allow for a seamless integration into your standard business practices.",
      footer:
        "*For fingerprint or iris identification, the system requires an external fingerprint reader or iris scanner, both of which can be purchased from",
      whychosse: " our Biometric Office Attendance System for your business?",
      whychossetitle: "Why choose",
      why: "Why",
      choose: "choose",
      increaseemploy: " Increase Employee Satisfaction",
      increaseemploydes:
        "Nothing dents employee satisfaction more than unpaid wages. Avoid unnecessary wage issues with an accurate time and management system that ensures that every employee is fairly compensated for their work.",
      streamline: "Streamline your HR",
      streamlinedes:
        "The customized reporting that CheckID FacialSense offers your business allows you to easily monitor, analyse and understand your workforce in real time, cutting down the need for cumbersome and confusing paperwork.",
      reduce: "Reduce Errors",
      reducedes:
        "Time and attendance monitoring is a data intensive task, that is prone to human error. The automated biometric office attendance software reduces the risk of mistakes, and ensures an impartial and orderly recording and presentation of data.",
      increaseproductivity: "Increase Productivity",
      increaseproductivitydes:
        "Biometric scanners remove the possibility of ‘buddy punching’, an employee clocking in and out for another. Therefore, you can rest easy knowing that your workforce is putting in the hours they say they are.",
      cost: "Cost Efficiency",
      costdes:
        "Not only does it reduce labor costs that arise as a result of inaccurate recordings, but the multiple face detection feature can be used to cut down on queues for the clocking in machine.",
      compre: "Comprehensive Reporting",
      comperdes:
        "Reports include summary on working hours, overtime, vacation, sick leave and other relevant information all of which can be exported to the payroll system.",
    },
    retailworkforce: {
      titlepage: "Retail Workforce | CheckID FacialSense Service",
      headertitle: "Retail Workforce",
      headertitle1: "Retail Workforce",
      retail1: "Retail",
      work: "Workforce",
      header: " Time & Attendance Monitoring System",
      theckeckid: "The CheckID FacialSense Bio Attendance system",
      uses: " uses ",
      biomatrici:
        "biometric identification of face, fingerprint and iris scanning",
      desbiomatric:
        " to efficiently monitor, manage and register attendance, without the need for specialist hardware.",
      thisal: "This AI - powered biometric technology helps",
      retail: " retail businesses ",
      tomain: "to maintain and enhance an ",
      effect: "efficient, productive and cost effective ",
      workfore:
        "workforce in among the fast-paced shop floor environment. Whilst the biometric technology is advanced, the reporting is simple, intuitive and flexible around your business requirements.",
      theckeckidFacial:
        "The CheckID FacialSense Bio Attendance system is a turnkey solution that has been designed to fit seamlessly into your business HR and payroll operations, whilst simultaneously ensuring your employees are accurately compensated for the shifts that they work without the need for cumbersome fobs, time cards or clocking in machines.",
      key: "Key",
      feature: " Features",
      desfeature:
        "The CheckID FacialSense Bio Attendance system has a number of powerful features designed to increase the efficiency and accuracy of employee time and attendance monitoring, including:",
      multiple: "Multiple face detection",
      multipledes:
        "Our biometric office attendance system can detect and recognize faces of all the people seen in the picture, meaning your staff do not have to waste time queuing for the clocking in machine.",
      contactless: "Contactless attendance tracking",
      contactlessdes:
        "No physical contact is needed when person is recognized by face or iris.",
      liveness: "Liveness detection",

      livenessdes:
        "Before starting facial recognition, the system can validate that the check-in / check-out is being attempted by a real person.",
    },

    livenessdes:
      "Before starting facial recognition, the system can validate that the check-in / check-out is being attempted by a real person.",

    mobileandremote: {
      titlepage: "Mobile & Remote Employee | CheckID FacialSense Service",
      header: "Mobile & Remote Employee",
      header3: "Mobile & Remote",
      header2: "Mobile &",
      mobile1: "Mobile",
      and1: "&",
      remote: "Remote",
      employee: "Employee",
      headermobile: " Time Tracking Software",
      recognise:
        "We recognise that in the current world of dynamic working, your company will likely be challenged in ways that it has not before, especially when it comes to attendance monitoring.",
      wewant:
        "We want to make sure you have no issues in accurately monitoring attendance remotely. ",
      thecheckid:
        "The FacialSense remote employee time tracking system, powered by biometrics, uses biometric identification of face, fingerprint and iris scanning",
      toeffect:
        "to efficiently monitor, manage and register attendance, even for mobile or remote employees.",
      thisall: "This AI - powered biometric technology will help",
      yourbussiness: " your business",
      and: "and others alike to maintain and enhance an ",
      effect: "efficient, productive and cost effective ",
      workfore:
        "workforce despite the challenges of employees working off-site. Whilst the biometric technology has advanced capabilities, the reporting and user interface is simple, intuitive and flexible around your business requirements. Our biometric remote employee time tracking software is a turnkey solution that has been designed to fit seamlessly into your business's HR and payroll operations.",
      thesystem:
        "The system is easy to use for your employees. If they have a phone, laptop or tablet, they can easily, quickly and accurately register their attendance!",
      key: "Key",
      features: "Features",
      keyfeatures: "Key Features",
      keyfeaturesdes: " of Remote Employee Time Tracking",
      carefull:
        "Carefully designed and built, our team here at CheckID FacialSense have delivered a software with numerous powerful features, purposefully created to increase the business efficiency of companies with a mobile workforce, including;",
      nospecific: "No specific user hardware required*",
      nospecificdes:
        "Our biometric remote employee time tracking software can be used by your remote employees via a phone, tablet or computer!",
      real: "Real-time face detection",
      realdes:
        "The system can detect the face of a person passing by without requiring to stop and wait while the camera takes a picture.",
      liveness: "Liveness detection",
      livenessdes:
        "Before starting facial recognition, the system can validate that the check-in / check-out is being attempted by a real person.",
      footer:
        "*For fingerprint or iris identification, the system requires an external fingerprint reader or iris scanner, both of which can be purchased from",
      whychosse:
        " our biometric time tracking software for your remote employees?",
      whychossetitle: "Why choose",
      why: "Why",
      choose: "choose",
      increasetem: "Increase Team Satisfaction",
      quickstart:
        "Step-by-step guides are provided for you to start with our time tracking software for remote employees",
    },
    student: {
      titlepage: "Student Attendance | CheckID FacialSense Service",
      header: "Student Attendance",
      student: "Student",
      attent: "Attendance",
      school: "School Biometric",
      school1: "School",
      bio1: "Biometric",
      schooldes: " Attendance System",
      thecheckid:
        "The CheckID FacialSense Biometric Attendance System for schools and colleges, plus universities alike, has been designed to benefit students, teachers, even when learning remotely.",
      wehave:
        "We have purposefully built this school biometric attendance system to allows schools, colleges and universities to effortlessly manage, capture and analyse student and staff attendance using the AI-powered biometric scanning of either the face, fingerprint or iris.",
      with: "With attendance being intrinsically linked to education, we are sure you are well aware it is vital for your educational institution to have an efficient and accurate time and attendance system in place. Having just recently come out of an era where learning from home was common practice, it is best to equipped with a school biometric attendance system which facilitates this possibility - our CheckID FacialSense system certainly fits that quota.",
      thesystem:
        "The system is a simple turnkey integration into your operations, ensuring your students are accurately registered whilst also removing bottlenecks in your school administration. Whilst the biometric technology offers advanced capabilities, the reporting and user interface is simple, intuitive and flexible around your administration requirements.",
      key: "Key",
      features: "Features",
      keyfeatures: "Key Features",
      keyfeaturesdes: " of our Biometric Attendance System for Schools",
      ourteam:
        "Our team of specialist developers intuitively built our School Biometric Attendance System so that it boasts a number of powerful features designed to help your educational institution accurately monitor and manage attendance:",
      multiple: "Multiple face detection",
      multipledes:
        "Our biometric office attendance system can detect and recognize faces of all the people seen in the picture, meaning your staff do not have to waste time queuing for the clocking in machine.",
      realtime: "Real-time face detection",
      realtimedes:
        "The system can detect the face of a person passing by without requiring to stop and wait while the camera takes a picture.",
      tail: "Tailored reporting",
      youcan:
        "You can set up your CheckID FacialSense reports to be flexible around your requirements to monitor student attendance.",
      whychossedes:
        "You may have been used to other forms of attendance monitoring, some more modern than others, so a change to a biometric system may sound daunting. This is why we have broken it down into simple terms so you can understand the numerous positive reasons as to why a biometric attendance system for schools and other educational facilities is a good fit for you:",
      whychosse:
        " the CheckID FacialSense School Biometric Attendance System for your Institution?",
      whychossetitle: "Why choose",
      why: "Why",
      choose: "choose",
      encourage: "Encourage attendance",
      encouragedes:
        "Attendance is a key factor in helping ensure students receive a high quality education. An accurate yet easy-to-use system ensures that there are no unnecessary factors that might affect attendance.",
      streamline: "Streamlined administration",
      streamlinedes:
        "The flexible reporting that CheckID FacialSense offers your education institution allows you to easily monitor, analyse and understand your students in real time. reducing the need for cumbersome and confusing paperwork.",
      reduce: "Reduce error risk",
      reducedes:
        "Time and attendance monitoring is a data intensive task, that is prone to human error. The automated CheckID FacialSense Bio Attendance system reduces the risk of mistakes, and ensures an impartial and orderly recording and presentation of data.",
      reducetruancy: "Reduce truancy",
      reducetruancydes:
        "Biometric devices will reduce ‘buddy punching’, one pupil clocking in/out for another. You can be assured that your pupils are present in the hours they are required to be so.",
      environ: "Environmentally friendly",
      environdes:
        "Cut down on your school’s paper trial by moving away from registers and attendance lists alike.",
      comprehensive: "Comprehensive Reporting",
      comprehensivedes:
        "Reports include summary on student attendance, days off, sick leave and other relevant data.",
    },
    constructtion: {
      titlepage: "Construction Site | CheckID FacialSense Service",
      header: "Construction Site",
      construct: "Construction",
      site: " Site",
      headerdes: " Time & Attendance Monitoring System",
      thecheckid:
        "The CheckID FacialSense Bio Attendance uses biometric identification of",
      face: " face, fingerprint and iris scanning",
      to: " to efficiently monitor, manage and register attendance on a large and flexible scale, without the need for specialist hardware.",
      accurate:
        "Accurate and efficient reporting of site attendance is vital for the success of large construction projects. The ever-changing and dynamic construction workforce is renowned for payroll errors, poor overtime management and uCheckID FacialSenseed absenteeism due to the constantly evolving schedules and project requirements. The Bio Attendance system also prevents the fraudulent or incorrect attendance recording associated with other attendance systems such as time cards, fobs or registers.",
      whilst:
        "Whilst the biometric technology has advanced features, the user interface and reporting is simple and intuitive and flexible around your business requirements. The CheckID FacialSense Bio Attendance system is a turnkey solution that has been designed to fit seamlessly into your construction site HR and payroll operations, helping your construction project to run smoothly, whilst also ensuring your remote workers are compensated fairly and accurately.",
      keyfeatures: "Key Features",
      key: "Key",
      fearures: " Features",
      keyfeaturesdes:
        "The CheckID FacialSense Bio Attendance system has a number of powerful features designed to increase the efficiency and accuracy of construction site time and attendance monitoring, including:",
      multiple: "Multiple face detection",
      multipledes:
        "Our biometric office attendance system can detect and recognize faces of all the people seen in the picture, meaning your staff do not have to waste time queuing for the clocking in machine.",
      location: "Location tracking",
      locationdes:
        "Our attendance system can track the geographical location of a person’s place of check-in / check-out.",
      liveness: "Liveness detection",
      livenessdes:
        "Before starting facial recognition, the system can validate that the check-in / check-out is being attempted by a real person.",
      hardhat: "Hardhat detection",
      hardhatdes:
        "Ensure your construction site staff are following safety procedures when entering your sites with automatic hardhat detection.",
      remote: "Remote Location Management",
      remotedes:
        "Working time of employees can be easily tracked and calculated even if person works remotely. Users can check-in and check-out simply with their mobile device, tablet or personal computer.",
      identification: "Identification with face mask",
      identificationdes:
        "Our biometric attendance system is able to recognize a person even if he/she is wearing a face mask, which ensures safe and hygienic identification.",
    },
    healthcare: {
      titlepage: "Healthcare | CheckID FacialSense Service",
      header: "Healthcare",
      headrdes: " Time & Attendance Monitoring System",
      thecheckid:
        "The CheckID FacialSense Bio Attendance uses biometric identification of",
      face: " face, fingerprint and iris scanning",
      to: " to efficiently monitor, manage and register attendance on a large and flexible scale, without the need for specialist hardware.",
      ideal: "Ideal for institutions that prioritize hygiene and cleanliness",
      notonly:
        "Not only do conventional fingerprint scanners pose a cross contamination risk, they also often prove futile or counter intuitive in environments where staff are expected to wear PPE such as disposable gloves.",
      checkidabbliti:
        "CheckID FacialSense’s ability to scan and identify via either the face, fingerprint or iris allows healthcare facilities to monitor attendance in the most hygienic and practical manner relevant to their requirements. Whilst the biometric technology has advanced features, the user interface and reporting is simple and intuitive, and has been designed as a turnkey solution that you can easily plug in to your current operations.",
      keyfeatures: "Key Features",
      key: "Key",
      fearures: " Features",
      keyfeaturesdes:
        "The CheckID FacialSense Bio Attendance system has a number of powerful features designed to hygienically monitor attendance for Healthcare Organizations",
      contactless: "Contactless attendance tracking",
      contactlessdes:
        "No physical contact is needed when person is recognized by face or iris.",
      liveness: "Multiple face detection",
      livenessdes:
        "Our biometric office attendance system can detect and recognize faces of all the people seen in the picture, meaning your staff do not have to waste time queuing for the clocking in machine.",
      mulbio: "Multiple biometrics",
      muldes: "3 biometric modalities are available - face, finger and iris.",
      multiple: "Multiple face detection",
      multipledes:
        "Our biometric office attendance system can detect and recognize faces of all the people seen in the picture, meaning your staff do not have to waste time queuing for the clocking in machine.",
    },
    service: {
      titlepage: "Service and Hospitality | CheckID FacialSense Service",
      header: "Service and Hospitality",
      header2: "Service and",
      hopital: " Hospitality",
      hopitaldes: "Time and Attendance Software for",
      thecheckid:
        "The CheckID FacialSense Bio Attendance uses biometric identification of",
      face: " face, fingerprint and iris scanning",
      to: " to efficiently monitor, manage and register attendance on a large and flexible scale, without the need for specialist hardware.",
      thisal: "This AI - powered biometric technology will help your",
      retail: " hospitality business ",
      tomain: "to maintain and enhance an ",
      effect: "efficient, productive and cost effective ",
      workfore: "workforce amongst the frantically-paced service environment.",
      whilst: "Whilst the biometric technology is advanced, the reporting is:",
      simple: "Simple",
      intuitive: "Intuitive",
      cusztom: "Customizable around your business requirements",
      our: "Our time and attendance software for hospitality system is a turnkey solution that has been designed to fit seamlessly into your business HR and payroll operations. Simultaneously, it will ensure your employees are accurately compensated for the time they invest during working hours. ",
      contactwithstart: " Contact Us To Get Started ",

      keyfeatures: "Key Features",
      key: "Key",
      fearures: " Features",
      keyfeaturesdes:
        "Our biometric systems have a number of powerful features designed to increase the efficiency of service by your business through effective time and attendance hospitality software. These include:",
      multiple: "Multiple face detection",
      multipledes:
        "Our biometric office attendance system can detect and recognize faces of all the people seen in the picture, meaning your staff do not have to waste time queuing for the clocking in machine.",
      nospecific: "No specific user hardware required*",
      nospecificdes:
        "Our biometric remote employee time tracking software can be used by your remote employees via a phone, tablet or computer!",
      liveness: "Liveness detection",
      livenessdes:
        "Before starting facial recognition, the system can validate that the check-in / check-out is being attempted by a real person.",
      location: "Location tracking",
      locationdes:
        "Our attendance system can track the geographical location of a person’s place of check-in / check-out.",
      remote: "Remote Location Management",
      remotedes:
        "Working time of employees can be easily tracked and calculated even if person works remotely. Users can check-in and check-out simply with their mobile device, tablet or personal computer.",
      compre: "Comprehensive Reporting",
      comperdes:
        "Reports include summary on working hours, overtime, vacation, sick leave and other relevant information all of which can be exported to the payroll system.",
      footer:
        "*For fingerprint or iris identification, the system requires an external fingerprint reader or iris scanner, both of which can be purchased from",
      benefit: "Benefits",
      foryou: " for your hospitality business?",
      employee: "Employee Satisfaction",
      employeedes:
        "Avoid unnecessary wage issues with an accurate time and management system that ensures every employee is fairly compensated for their work.",
      streamline: "Streamline your HR",
      streamlinedes:
        "The customized reporting that CheckID FacialSense offers your business allows you to easily monitor, analyse and understand your workforce in real time, cutting down the need for cumbersome and confusing paperwork.",
      reduce: "Reduce Errors",
      reducedes:
        "Time and attendance monitoring is a data intensive task, that is prone to human error. The automated biometric office attendance software reduces the risk of mistakes, and ensures an impartial and orderly recording and presentation of data.",
      increaseproductivity: "Increase Productivity",
      increaseproductivitydes:
        "Biometric scanners remove the possibility of ‘buddy punching’, an employee clocking in and out for another. Therefore, you can rest easy knowing that your workforce is putting in the hours they say they are.",
      cost: "Cost Efficiency",
      costdes:
        "Not only does it reduce labor costs that arise as a result of inaccurate recordings, but the multiple face detection feature can be used to cut down on queues for the clocking in machine.",
      compredes1:
        "Find all of your comprehensive reports in one place, helping save the time and investment of managing different facets of the business separately and remove the worry of inaccurate reporting.",
      client: "Client",
      testimonials: " testimonials",
      items: {
        description:
          "“We are using this software in our school for taking attendance of staff and found very useful. This software register all our staff’s detail and biometrics information quickly and we immediately started taking the attendance of our staff. We have been able track the absentee of our staff and late comers. We have been able to take the attendance report on daily basis very quickly without any trouble.”",
        name: "Seema C.",
        position: "Teacher, Red Roses Public School",
      },
    },
    factory: {
      titlepage: "Factory and Warehouse | CheckID FacialSense Service",
      header: "Factory and Warehouse",
      headerder2: "Factory and ",
      warehose: "Warehouse ",
      headerdes: " Employee Time & Attendance Monitoring System",
      thecheckid:
        "The CheckID FacialSense Bio Attendance system is a favorite among employers for its ability to maintain and enhance an efficient, productive and cost effective workforce, without the need for specialist hardware.",
      checkid:
        "CheckID FacialSense’s time and attendance monitoring system uses",
      biometric:
        " biometric identification of face, fingerprint and iris scanning",
      thesystem:
        ". The system is a simple turnkey integration into your HR and Payroll operations, ensuring your employees are accurately compensated whilst also removing bottlenecks in your payroll administration.",
      whilst:
        "Whilst the biometric technology offers advanced capabilities, the reporting and",
      user: " user interface is simple, intuitive and customizable",
      around:
        " around your business requirements, allowing you to harness these AI-powered capabilities for your own business.",
      key: "Key",
      keyfeatures: "Key Features",
      fearures: "Features",
      keyfeaturesdes:
        "Our biometric systems have a number of powerful features designed to increase the efficiency of service by your business through effective time and attendance hospitality software. These include:",
      multiple: "Multiple face detection",
      multipledes:
        "Our biometric office attendance system can detect and recognize faces of all the people seen in the picture, meaning your staff do not have to waste time queuing for the clocking in machine.",
      realtime: "Real-time face detection",
      realtimedes:
        "The system can detect the face of a person passing by without requiring to stop and wait while the camera takes a picture.",
      turnkey: "Turnkey solution",
      turnkeydes:
        "CheckID FacialSense biometric office attendance system requires no specialist hardware*, and easily integrates with the leading payroll providers to allow for a seamless integration into your standard business practices.",
      footer:
        "*For fingerprint or iris identification, the system requires an external fingerprint reader or iris scanner, both of which can be purchased from",
    },
    agriculture: {
      titlepage: "Agriculture | CheckID FacialSense Service",
      header: "Agriculture",
      headerdes: " Sector Time & Attendance Monitoring System",
      thecheckid:
        "The CheckID FacialSense Bio Attendance uses biometric identification of face, fingerprint and iris scanning to efficiently monitor, manage and register attendance on a large and flexible scale, without the need for specialist hardware*.",
      accurate:
        "Accurate and efficient reporting of site attendance is vital for the success of large agricultural projects. The management of the ever-changing and dynamic workforce is renowned for payroll errors, poor overtime management and uCheckID FacialSenseed absenteeism due to the constantly evolving schedules and project requirements. The CheckID FacialSense Bio Attendance system also prevents the fraudulent or incorrect attendance recording associated with other attendance systems such as time cards, fobs or registers.",
      whilst:
        "Accurate and efficient reporting of site attendance is vital for the success of large agricultural projects. The management of the ever-changing and dynamic workforce is renowned for payroll errors, poor overtime management and uCheckID FacialSenseed absenteeism due to the constantly evolving schedules and project requirements. The CheckID FacialSense Bio Attendance system also prevents the fraudulent or incorrect attendance recording associated with other attendance systems such as time cards, fobs or registers.",
      fearuresdes:
        "Our biometric systems have a number of powerful features designed to increase the efficiency of service by your business through effective time and attendance hospitality software. These include:",
    },
    organizations: {
      titlepage: "Organization | CheckID FacialSense Service",
      header: "Organization",
      headerdes: "Meet a person in the ",
      headernone: "organization",
      usually:
        "Usually, in an organization, employees have to meet their guest who are coming to the office or any other location. Depending on the situation, this meeting may happen inside office premises (in meeting room) or any other location. For this scenario, CheckID FacialSense Visitor Management can be used to set up a meeting schedule at the meeting location. Visitors can book appointments for this schedule time slot,  and employee can finish all meetings with visitors in a shorter time.",
      thecheckid:
        "CheckID FacialSense Visitor management system can be configured to send notifications on different events, for both employee and visitor. Such as notifying the employee when visitor checked in with the system. Then employee need to visit the specified location to meet the guest.",
      when: "When using CheckID FacialSense Visitor management system, employee can meet all visitors in shorter time period, because meeting visitors throughout the day is not practical, so employee may spend some dedicated time or their free time for that purpose. Also visitors can come and meet the employee, without been waiting in the office lobby area. So, both employee and visitor time is not wasted.",
      usecase: "Use case",
      use: "Use",
      case: " case",
      usecaseheader: " example",
      employee: "Employee: Define time schedule",
      employeedes:
        "Employee may decide the time slot and place that he/she wish to meet visitors. Then from the system create a schedule according to that.",
      consumer: "Visitor: Place an appointment",
      consumerdes:
        "Visitors can check online and place an appointment to meet employee. Also if walk-in appointments allowed, visitor can place appointment from the registration kiosk.",
      fresh: "Visitor: Check-in to the appointment",
      freshdes:
        "After entering the premises, visitor can check-in with the system with their appointment ID. System can be configured to use a generated ID or a physical ID such as government ID card.",
      buyer: "Progress and concluding",
      buyerdes:
        "Leads are viewable in our CRM, or can be synced to one of 700 CRM systems",
      leads: "Progress and concluding",
      leadsdes:
        "The employee can come to meet visitors when notification is received. After the meeting, the visitor will check-out from the meeting place and the employee can mark the appointment as completed.",
      buytweak: "Buyers tweak their lead sources",
      buytweakdes:
        "Disposition data allows buyers to see exactly what their cost per sale per website they received leads from.",
      keyfeatures: "Key Features",
      thecheckid2:
        "The CheckID FacialSense Visitor Management system has a number of powerful features designed to provide convenient and secure experience for all visitors while reducing the visitor management complexity and burden on employees. Our system has many features including:",
      online: "Online pre appointments",
      onlinedes:
        "Online pre-appointment allows visitors to plan their visit in advance and access hassle-free.",
      secure: "Secure visitor access",
      securedes:
        "Barcode, RFID, face, fingerprint, and iris recognition provide fast, efficient, and secure access for visitor appointments and interaction with visitors.",
      feedback: "Safe and hygienic",
      feedbackdes:
        "Touchless barcode, RFID, facial, and iris recognition technology that provides no-contact visitor identification.",
    },
    travel: {
      titlepage: "Travel and Excursion | CheckID FacialSense Service",
      header: "Travel and Excursion",
      headerTravel: "Travel and excursion",
      after:
        "After the covid-19 pandemic, tourism industry is just started to recovery. Many tourist destinations around the world resumed their operations with more health and safety precautions. Accepting visitors from different countries and maintaining health and safety is a huge responsibility for a tourist destination. Here we are considering all the parks, museums, historical or attractive destinations that providing services to all tourists.",
      asan: "As an organization, each tourist attraction need some information about the visitor. As for the current post-pandemic situation, visitor's vaccinated state is a must to know. Other than that, organization need to know visitor's name, age, language etc. to provide customized experience. For an example, language can be used to provide guidance in visitor's own language. Also some places like museums need tickets for visitors, and visitors may want to book their tickets for a future day visit.",
      with: "With CheckID FacialSense Visitor management, such travel destination/organization can collect the information they need from visitors. These information can be customized upon request. With online booking facility, visitor can book for a future date as well. Those who wish to visit within same day, walk-in kiosk will collect the same information as the online registration. Addition to booking, ticket issuing and printing also possible with such setup.",
      organiza: "Organization: define time slots for tourists",
      organizades:
        "Management at the tourist destination/attraction can define time slots that visitors can visit and see. In the same time tickets can be sold from the system.",
      visitor: "Visitor: book an appointment",
      visitordes:
        "Visitors can check online and place an appointment to visit the location. If passes/tickets issued from the gate, it can be managed using one more kiosk devices at the entrance.",
      visitorCheckin: "Visitor: Check-in to the location",
      visitorCheckindes:
        "After entering the location, visitor data will be used to provide customized experience inside the premises. Access to certain sections can be restricted, visitor's language preference can be used to give details in their own language, use different tone for children etc are few possible use cases of visitor data.",
      ending: "Ending the visit and leaving",
      endingdes:
        "When visitor finished exploring of the place, they can give their feedback and leave.",
      keyfeaturesdes:
        "The CheckID FacialSense Visitor Management system has a number of powerful features designed to provide convenient and secure experience for all visitors while reducing the visitor management complexity and burden on employees. Our system has many features including:",
      custom: "Customizable registration",
      customdes:
        "Online booking and Kiosk booking can be modified to collect different visitor information based on customer requirement.",
      contact: "Contactless access",
      contactdes:
        "No physical contact is needed when person is recognized by face or iris.",
      issuing: "Issuing tickets",
      issuingdes:
        "A ticket or a pass can be generated and print. Contents of the ticket can be modified according to customer needs.",
    },
    banking: {
      titlepage:
        "Banking or Financial Institutes | CheckID FacialSense Service",
      header: "Banking or Financial Institutes",
      headernone: "Banking or financial institutes",
      finacial:
        "Financial institutes like banks have their main focus on security. Such institution should consider safety of their own employees and property, as well as the customers who visit the bank. Since personal verification is the most important point, most banks use biometrics for authentication purposes.",
      there:
        "There are some areas in the bank that are not allowed for the customer. It is vital that ensuring no customer will enter those areas. Banks collect some considerable private data from their customers, so need to ensure their safety at any cost.",
      checkid:
        'CheckID FacialSense visitor management provide "Face", "Fingerprint" and "Iris" biometric modalities powered by most reliable Neurotechnology Biometric SDK. Also additional verification step can be introduced to improved security.',
      bank: "Bank: define business hours for customers",
      bankdes:
        "Management of the bank can define business hours for customers. Each purpose will have an associated location. (E. g: Requesting a loan: at credit department)",
      custom: "Customer: place an appointment with bank",
      customdes:
        "Customers can make a request by explaining their requirement. An officer from the bank can check the request and can accept/edit or reject the request.",
      customvisit: "Customer: visit the bank",
      customvisitdes:
        "Customer will be authenticated upon arrival. Bank can use customer's biometric to identify the person. As additional safety measure, bank can ask for scan the passbook or ID card. upon verification, customer is allowed to enter the relevant section.",
      leave: "Leaving the premises",
      leavedes:
        "After getting completed the requested job from the bank, customer may leave the feedback in the check-out device and leave the premises.",
      fearuresdes:
        "The CheckID FacialSense Visitor Management system has a number of powerful features designed to provide convenient and secure experience for all visitors while reducing the visitor management complexity and burden on employees. Our system has many features including:",
      biometric: "Biometric visitor recognition",
      biometricdes:
        "Face, fingerprint and iris visitor recognition in access control and visitor management",
      contact: "Contactless access control",
      contactdes:
        "No physical contact is needed when person is recognized by face or iris and access control devices operate only for authenticated visitors.",
      data: "Data privacy",
      datades:
        "Visitor operations are performed by authorized personnel, so visitor and visit information is guaranteed from unauthorized access.",
    },
    hotel: {
      titlepage: "Hotels and Restaurants | CheckID FacialSense Service",
      header: "Hotels and Restaurants",
      headernone: "Hotels and restaurants",
      inthe:
        "In the tourism industry, hotels and restaurants also need to have some information about their guests. There may be several reasons, but most important thing is ensuring safety of all guests. This may be a health concern or a security concern. ID card for local guests and passport or travel document from foreign guests are the most common document required when hotel booking.",
      when: "When comes to restaurants, this information may be less important, but collecting the food/beverage preference at early will be convenient for guest as well. At the time of booking, hotel or restaurant can get the selected menu for breakfast, lunch, tea etc. and guest can enjoy their time without calling room services frequently.",
      for: "For a frequent visitor, having previous check-in details with the system may be an advantage, also hotel/restaurant can offer a special price for such guests.",
      organiza: "Organization: define time slots for tourists",
      organizades:
        "Management at the tourist destination/attraction can define time slots that visitors can visit and see. In the same time tickets can be sold from the system.",
      visitor: "Visitor: book an appointment",
      visitordes:
        "Visitors can check online and place an appointment to visit the location. If passes/tickets issued from the gate, it can be managed using one more kiosk devices at the entrance.",
      visitorCheckin: "Visitor: Check-in to the location",
      visitorCheckindes:
        "After entering the location, visitor data will be used to provide customized experience inside the premises. Access to certain sections can be restricted, visitor's language preference can be used to give details in their own language, use different tone for children etc are few possible use cases of visitor data.",
      ending: "Ending the visit and leaving",
      endingdes:
        "When visitor finished exploring of the place, they can give their feedback and leave.",
      bank: "Bank: define business hours for customers",
      bankdes:
        "Management of the bank can define business hours for customers. Each purpose will have an associated location. (E. g: Requesting a loan: at credit department)",
      customer: "Customer: place an appointment with bank",
      customerdes:
        "Customers can make a request by explaining their requirement. An officer from the bank can check the request and can accept/edit or reject the request.",
      customvisit: "Customer: visit the bank",
      customvisitdes:
        "Customer will be authenticated upon arrival. Bank can use customer's biometric to identify the person. As additional safety measure, bank can ask for scan the passbook or ID card. upon verification, customer is allowed to enter the relevant section.",
      leaving: "Leaving the premises",
      leavingdes:
        "After getting completed the requested job from the bank, customer may leave the feedback in the check-out device and leave the premises.",
      hotel: "Hotel/restaurant: accept bookings or reservations",
      hoteldes:
        "Hotel operational staff can define number of bookings available according to rooms availability. Guests can make reservation any time so manually accepting/rejecting reservations is not required. When all rooms booked, guests will not be able to book further.",
      guest: "Guest: make the reservation",
      guestdes:
        "Guest can place the reservation online or using reservation kiosk.",
      guestCheck: "Guest: Check-in to the premises",
      guestCheckdes:
        "When guest check-in to the premises, reception will get a notification and they can proceed further, like serving a welcome drink.",
      endingStay: "Ending the stay and check-out",
      endingStaydes:
        "At the end of the stay, guest will check-out from the system. Additionally, bills can be generated for the stay and food.",
      fearuresdes:
        "The CheckID FacialSense Visitor Management system has a number of powerful features designed to provide convenient and secure experience for all visitors while reducing the visitor management complexity and burden on employees. Our system has many features including:",
      bio: "Biometric visitor recognition",
      biodes:
        "Face, fingerprint and iris visitor recognition in access control and visitor management",
      automated: "Automated access control",
      automateddes:
        "Visitor restricted and allowed gates and doors are controlled with attendance devices.",
      custom: "Customizable registration",
      customdes:
        "Online booking and Kiosk booking can be modified to collect different visitor information based on customer requirement.",
    },
    consultation: {
      titlepage: "Consultation Services | CheckID FacialSense Service",
      header: "Consultation Services",
      headernone: "Consultation services",
      consultation:
        "Consultation services are great way to get advice from an expert in the field. These services span on many areas including medical, technical, personal counseling etc. Experts can directly provide consulting service, or some intermediate institution acts behalf of the consultant and manage the reservations. In the consulting field, customers may need to share their personal and private details with the consultant. In medical consulting, clinical history should be shared with the doctor and it's a confidential detail. So the institute who manage the customer data on behalf of the consultant have the responsibility to keep those data secure. Also consultant may need to refer details and notes from previous consultations.",
      with: 'With CheckID FacialSense Visitor management, using the "Consultant" scenario, an organization can manage schedules for consulting. Defining a time slot for consulting, keeping notes on the session, referring previous consultation data can be done using the system.',
      institution:
        "Institution: Create consultation schedules behalf of the consultant.",
      institutiondes:
        "For different consultants, institution may create different schedules based on their available time and assign a place (room) for the session. Also time per consulting session and consultant fee also can be mentioned within the schedule.",
      guestreserve: "Guest: reserve an appointment with consultant.",
      guestreservedes:
        "Guest can use online booking or kiosk booking if available. Once the number of appointments per day is booked, guests cannot book for the same day.",
      guestcheck: "Guest: Check-in to the premises",
      guestcheckdes:
        "Guest will produce the reservation ticket to the reception for confirm check-in and pay any consultant fees.",
      ending: "Ending the session",
      endingdes:
        "At the end of the session, guest may check-out from the system. If there are any other activity like getting prescribed medicine, the ticket can be used at the pharmacy",
      fearuresdes:
        "The CheckID FacialSense Visitor Management system has a number of powerful features designed to provide convenient and secure experience for all visitors while reducing the visitor management complexity and burden on employees. Our system has many features including:",
      electronic: "Electronic pass",
      electronicdes:
        "Automatic pass generation or specified electronic pass such as Barcode, RFID, Vehicle License plate are allowed to use as guest pass",
      contact: "Contactless attendance tracking",
      contactdes:
        "No physical contact is needed when person is recognized by face. This is most important for Hospitals.",
      customer: "Customizable visit notes",
      customerdes:
        "Customizable visit notes with forms and attachments can be used to create detailed visit logs",
    },
    building: {
      titlepage: "Building and Apartments | CheckID FacialSense Service",
      header: "Building and Apartments",
      headerdes: "Visitor Management System for",
      headerdesapr: "Visitor Management System for Apartments ",
      ensure:
        "Ensure your apartment block and any other particular building has the ability to grant access to planned visitations easily and efficiently courtesy of CheckID FacialSense's visitor management system for apartments.",
      sercuity:
        "Security and privacy is a must for residents and users of these premises. They can rest assured that guest visitations are able to access the complex only if they have complied with our biometric visitor management software. Visitors access can be granted access only for specific locations if selected, so if somebody tries to enter an unauthorized area, access will be denied and such incidents should be reported to security personnel.",
      using:
        "Using the CheckID FacialSense visitor management system for apartments will transform and streamline the process for which guests, such as, cleaners or maintenance workers can enter the complex without causing any disruptions to residents and create more time for them to carry out the reason for their visit.",
      quickdes:
        "Step-by-step guides are provided for you to start with the CheckID FacialSense visitor management system for apartments. Both the Cloud based and On-Premise systems have been designed to be easy to use for both your organization and the visitor. Simply register, download and configure the system around your requirements, define your visit schedules and allow visitors to make appointments via online or using registration kiosk.",
      create: "Create a visitor schedule",
      createdes:
        "Management of the apartment can create this schedule to allow visitors to request access. When visit request received, management will confirm with other party (host) and confirm the access appointment.",
      guest: "Guest: Ask for a visit",
      guestdes:
        "Guest can place appointment online or from kiosk device at the location. When visit request received, management will confirm with other party (host) and confirm the access appointment. Visitor will get a temporary pass on confirmation.",
      guestCheck: "Guest: Check-in to the location",
      guestCheckdes:
        "At the security gate, guest will check in and produce the temporary pass to security. They will issue an access card to use at access doors.",
      leaving: "Leaving the building",
      leavingdes:
        "When guest leaving the premises, he/she may return the pass provided by the security and at the same time, Visitor may check-out from the system and visit appointment will be marked as completed.",
      keyfeatures:
        "The CheckID FacialSense Visitor Management System for Apartments has a number of powerful features designed to provide convenient and secure experience for all visitors while reducing the visitor management complexity and burden on employees. Here are some of the main features you will experience from integrating our system:",
      automated: "Automated access control",
      automateddes:
        "Visitor restricted and allowed gates and doors are controlled with attendance devices.",
      secure: "Secure visitor access",
      securedes:
        "Barcode, RFID, Face, Fingerprint and Iris visitor recognition provides fast, efficient and secure access for visitor appointments and interaction with visitors.",
      realtime: "Realtime visitor analytics",
      realtimedes:
        "Visitor attendance devices records visitor access and access denied information in the system.",
      whycheckid: "Why CheckID FacialSense Visitor Management System for ",
      apartment: "Apartments",
      willmake: " will make a difference ",
      increase: "Increase Visitor Satisfaction",
      increasedes:
        "The best way to satisfy a visitor is making their visit more productive. Reduce their time spent in queues and let them finish their job earlier for the optimal visitor experience within the premises.",
      see: "See who's inside",
      seedes:
        "CheckID FacialSense Visitor management system for apartments allows administrators to see how many visitors inside, by location and make appropriate plans to avoid congestion. For more convenience, customized reports can be scheduled to receive by e-mail.",
      automatedaccess: "Automatic access control",
      automatedaccessdes:
        "Access devices identify visitors and executes access control. Administrators can see the logs of visitor access and who has been denied access courtesy of the stored face image. Custom actions can be configured to perform additional functions, like opening a door or starting an alarm.",
      data: "Data and privacy",
      datades:
        "Visitor information is only accessible to authorized personnel within the organization, so all the personal and biometric information will be safe from intruders.",
      quickly: "Quick and simple registration",
      quicklydes:
        "Making an appointment should definitely be a simple process. We have simplified this by introducing online appointments and kiosk device for walk-in visitors.",
      customizable: "Customizable visitor interface",
      customizabledes:
        "CheckID FacialSense Visitor Management for apartments includes predefined scenarios for different use cases. If you need changes made to the visitor info collection or including a custom logo etc, please contact us and we can customize this.",
      key: "Key Features",
    },

    customer: {
      titlepage: "Customer Support | CheckID FacialSense Service",
      header: "Customer Support",
      headernone: "Customer support",
      allbuissess:
        "All businesses need a separate section for customer affairs. Customers will come for various reasons. Paying bills, repairing stuff, complains, after sales services and many reasons will be there. Officer at the reception will ask about the matter of visit, and based on given information, customer will be provided a ticket to meet a support officer.",
      using:
        "Using CheckID FacialSense Visitor management, reception officer may create appointments for different customer support officers. At each officer desk, there will be an overhead display to show current appointment number and next appointments. Customer may wait in the queue and meet the officer when their turn has come.",
      customer:
        "Customer support officer also have an attendance device. Support office will complete the appointment and close the matter.",
      create: "Create schedules: for each support officer",
      createdes:
        "In a customer support center, different employees share the customer base and some employees are specialists on certain areas. Each employee handle customers alone.",
      resception: "Receptionist: get customer requirement and place a ticket",
      resceptiondes:
        "Receptionist is the person who know the potential of each support officer. based on the availability, reception officer create an appointment and provide ticket for customer. Ticket will have the counter number, so customer can wait there.",
      address: "Addressing the matter and conclude",
      addressdes:
        "Support officer may attend the customer issue and complete the appointment. At the end, officer may ask customer to give feedback on check-out screen.",
      featuredes:
        "The CheckID FacialSense Visitor Management system has a number of powerful features designed to provide convenient and secure experience for all visitors while reducing the visitor management complexity and burden on employees. Our system has many features including:",
      auto: "Auto generated pass",
      autodes:
        "Automatic pass generation or specified electronic pass such as Barcode, RFID, Vehicle License plate are allowed to use as guest pass",
      overhead: "Overhead display",
      overheaddes:
        "Visitor management client device can be configured as an overhead display to show current and next appointments",
      feedback: "Feedback on check-out",
      feedbackdes:
        "Customer can rate their experience when checking out. Such information will be useful to measure service quality of employees.",
    },
    entertainment: {
      titlepage: "Entertainment | CheckID FacialSense Service",
      header: "Entertainment",
      headerdes: "Kiosk Visitor Management ",
      system: "System Solution",
      here: "Here at CheckID FacialSense, our expert team of attendance monitoring enthusiasts have created a kiosk visitor management system, perfect for integration at your entertainment attraction. ",
      entertainment:
        "Entertainment destinations like movie theatres, amusement parks, carnivals and public parks are often over-crowded during holidays and weekends. Visitors want to enjoy the attraction they are choosing to visit and spend as much time in the venue as possible. Helping bring this to fruition is the quick and easy to use kiosk based visitor management system solution, so your guests can efficiently and safely gain access to the venue. ",
      with: "With CheckID FacialSense, our system can offer simple forms with very few visitor details required, like name & age, and proceed to buy tickets. Visitors can book the tickets online and print them, or from the kiosk device at gate they can book tickets. Printing a ticket can be configured via an external printer connected to kiosk. At the entrance, visitors can scan the ticket with the device. If the ticket is marked as paid, they will get access to your venue.",
      control: "Control Visitor Access with ",
      simplicity: " Simplicity",
      management: "Management: Have schedule per event/movie/location",
      managementdes:
        "Management should create multiple schedules per event or location to allow visitors to book themselves.",
      visitor: "Visitor: select an event/movie/location and place booking",
      visitordes:
        "Visitor can book from the online site, and also use the kiosk device located on premises. If the site has multiple locations, multiple kiosk visitor management systems can be configured to book only specific schedules. After booking, ticket will be issued and any payment will be required. Cashier will mark the ticket as paid (set to completed).",
      it: "It's fun time!",
      itdes:
        "Once the ticket is validated (e.g. if there is a required payment), the ticket will be valid to enter the premises. Visitors can leave at any time.",
      quickstartheader:
        "Quick start guide for CheckID FacialSense Visitor Management Kiosk Systems",
      quickstartdes:
        "Step-by-step guides are provided for you to start with our system solutions so you can waste no time in getting underway and receive any helpful tips that you may require",
      fearuresdes:
        "The CheckID FacialSense Visitor Management system has a number of powerful features designed to provide convenient and secure experience for all visitors while reducing the visitor management complexity and burden on employees. Our system has many features including:",
      auto: "Auto generated pass",
      autodes:
        "Automatic pass generation or specified electronic pass such as Barcode, RFID, Vehicle License plate are allowed to use as guest pass",
      overhead: "Overhead display",
      overheaddes:
        "Visitor management client device can be configured as an overhead display to show current and next appointments",
      feedback: "Feedback on check-out",
      feedbackdes:
        "Customer can rate their experience when checking out. Such information will be useful to measure service quality of employees.",
      whychossedes: " our Visitor Management Kiosk Systems?",
      increase: "Increase Visitor Satisfaction",
      increasedes:
        "Satisfy your visitors by making their visit more productive. Reducing wasted time spent in queues so they can enjoy more time in the venue will positively effect their experience within your venue.",
      see: "See who's inside",
      seedes:
        "CheckID FacialSense kiosk based visitor management system allows administrators to see how many visitors are inside, by location and make appropriate plans to avoid congestion. For more convenience, customized reports can be scheduled to receive by e-mail.",
      automatedaccess: "Automatic access control",
      automatedaccessdes:
        "Each system device identifies the visitor and performs access control. Administrators have access to authorized and unauthorized visitor logs. Custom actions can be configured to perform additional functions, such as opening a door or starting an alarm.",
      data: "Data and privacy",
      datades:
        "Visitor information is only accessible to authorized personnel within the organization, so all the personal information will be safe from outside intruders.",
      quickly: "Quick and simple registration",
      quicklydes:
        "We have simplified the guest registration process by introducing online appointments and visitor management system kiosk devices for walk-in visitors.",
      customizable: "Customizable visitor interface",
      customizabledes:
        "We have included predefined scenarios for different use cases. In any case you need to implement changes to the visitor info collection or including a custom logo etc, please contact us.",
    },
    school: {
      titlepage: "Schools and Campuses | CheckID FacialSense Service",
      header: "Schools and Campuses",
      visitor: "Visitor Management System for ",
      school: "Schools",
      our: "Our CheckID FacialSense visitor management system for schools is a game-changer for educational institutions, creating an easy-to-use and biometrical powered system that transforms guest visitations. Whether you are booking in visits to show around potential pupils and their family or have visitors delivering an educational seminar to the students - our visitor management system for school is the perfect solution.",
      classdefine: "Class: Define time schedule",
      classdefinedes:
        "Your institution will be able to determine and set the availability of the lecturer/teacher and define class schedules based around their availability.",
      classselect: "Student: select a class time",
      classselectdes:
        "Your students can select their class times based on what works for them with varying schedules.",
      student: "Student: attend the class",
      studentdes:
        "At the class premises, students can show their class card to the NCheck visitor management system for schools and their attendance will be marked and entry will be granted.",
      afterclass: "After class",
      afterclassdes:
        "The visit notification feature can be used to deliver class notes/e-documents to students via e-mail.",
      quicklydes:
        "Step-by-step guides are provided so you can get underway in setting-up your CheckID FacialSense Visitor Management Systems for schools. ",
      if: "If you are unsure on anything mentioned in the quick start guides then do not hesitate to ",
      contact: " contact us ",
      anda: " and a member of our team will get back to you. ",
      keyfeatures: "Key Features",
      ofour: " of our Visitor Management System for Schools",
      keyfeaturesdes:
        "We wanted to deliver a system that is packed full of capabilities. Our team of specialized experts created this innovative school visitor management system for educational institutions of all levels. Our goal was to reduce the guest visitation complexity and burden on employees, and instead provide a convenient and secure experience for all visitors to your school. Our visitor management system for schools has many features including:",
      online: "Online pre appointments",
      onlinedes:
        "Online pre-appointment allows visitors to plan visits in advance and hassle-free access.",
      secure: "Secure visitor access",
      securedes:
        "Barcode, RFID, Face, Fingerprint and Iris visitor recognition provides fast, efficient and secure access for visitor appointments and interaction with visitors.",
      safe: "Safe and hygienic",
      safedes:
        "Touchless barcode, RFID, facial and Iris recognition technology provides non touch visitor identification.",
      auto: "Automated access control",
      autodes:
        "Visitor-restricted gates are controlled with attendance devices so access can be successfully granted.",
      real: "Real-time visitor analytics",
      realdes:
        "Visitor attendance devices record instances of access-granted and access-denied information in the system.",
      elec: "Electronic pass",
      elecdes:
        "Automatic pass generation or specified electronic passes such as Barcode, RFID, and vehicle license plate are allowed to use as a guest pass.",
      bio: "Biometric visitor recognition",
      biodes:
        "Access control and management systems use multimodal biometric recognition.",
      cuztom: "Customizable visit notes",
      cuztomdes:
        "Customized visitation notes with forms and attachments can be used to create detailed visitor logs.",
      data: "Data privacy",
      datades:
        "Visitor operations are performed by authorized personnel, so any relevant information is safeguarded from unauthorized access.",
      transfrom: "Transform",
      howyou:
        " how you manage visitations with our Visitor Management System for Schools",
      transfromdes:
        "Our system has been carefully designed so that it is not only applicable, but makes for the perfect guest visitation system for your institution. We understand that schools vary considerably in different parts of the world with the way they are built and the administration system they have in place. This is why our school visitor management system for education levels of all types has been intricately manufactured so that it can be easily integrated  onto your premises. ",
      choosing:
        "Choosing our visitor management system for your school will deliver on the following:",
      glowing: "Glowing first impression to new visitors ",
      equipped: "Equipped with the latest, modern technology",
      safetransfrom:
        "Safe and secure environment enabled through the biometric functionality ",
      encrypted: "Encrypted database for secure data of your visitors",
      save: "Save lots of administrative time and effort that can be put to use elsewhere within the school ",
      quick:
        "Quick and easy way to view the analytics at any given moment during the day ",
      remote:
        "Remote access for booking appointments and checking-in for visitations that are off-premise ",
      getstart: "Get Started Today",
      wehope:
        "We hope to hear from you to help transform how your school handles guest visitations.",
    },
  },
  pricing: {
    header: "Pricing",
    employee: "Employee (s)",
    headernone: "CheckID FacialSense Bio Attendance",
    cloud: "Cloud",
    onpremises: "On-premises",
    price: "Limited to 3 months",
    price1: "First 30-days for free.",
    price2: "Price per user 0.87$",
    price3: "First 30-days for free.",
    freePLan: "Free plan",
    free1: "Standard",
    free2: "Custom plan",
    free3: "Premium",
    month: "/ month",
    users: "Users",
    employee1: "up to 5 employees",
    employee2: "$ 1.50 per employee",
    employee3: "$ 3.00 per employee",
    mostporpular: "Most popular",
    getstart: "Start 30-day FREE trial",
    prices: "Prices do not include local import duties or taxes",
    freeclient: "Free client applications",
    foremploy:
      " for employees/users (Windows, Android and iOS operating systems) are available.",
    custom: "Custom solutions",
    make: "Make sure to leave us a message and we will be sure to get back to you as soon as possible.",
    licensefor: "1 license for 1 device - 95$",
    license: "License",
    one: "/ one time purchase",
    these: "These licenses can be used by following applications:",
    checkid:
      "CheckID FacialSense on-premise server (supported up to 100 users)",
    checkidstandrad: "CheckID FacialSense Standard client",
    addtocart: "Add to cart",
    formore: "For more than 100 users or more than 10 devices please ",
    contactus: "contact us",
    solutions: "Get in touch for custom solutions just for you!",
    solutions1: "Have a company with over 500 employees?",
    solutions2: "Need a license for more than 100 users?",
    solutions3: "Require a license for more than 10 devices?",
    solutions4: "Let us customize a solution to meet your specific needs.",
    customus: "Contact us",
    vissit: "Visitor Management",
    appoint: "Price per appointment free",
    appoint1: "Price per appointment 0.03$",
    appoint2: "Price per appointment 0.02$",
    appoint3: "Price per appointment 0.02$",
    dayaponit: "Appointments/day",
    preces: "Prices do not include local import duties or taxes",
    server: "Server License",
    unlitmit:
      "CheckID FacialSense Visitor management on-premise server (unlimited appointments)",
    client: "CheckID FacialSense Visitor client",
    ser: "CheckID FacialSense Visitor management server",
    freemon: "Free",
    customplan1: "Usually for companies with more than 500+ employees.",
    customplan2:
      "Feel free to contact us so we can create a plan just for you!",
    sign: "Sign up now!",
    contact: "Contact us",
    premises: "Available on premises",
    fearures:
      "System features will be customized according to your personal needs.",
    note: "note",
    freePlan:
      "Free plan users have the opportunity to upgrade their subscription to",
    freeForLife: "Free for life",
    byShareTheirSystemExperience:
      "by sharing their system experience through the system dashboard.",
    face: "Face",
    gpsTracking: "GPS Tracking",
    faceMaskDetection: "Face mask detection",
    timesheetAndReport: "Timesheets and Reports",
    personalDevicePerEmployee: "1 personal device per employee",
    devidePerEmployeeGroup: "1 device per employee group",
    workShedule: "Work schedules",
    videoTracking: "Visitor tracking, up to 100 visits",
    everythingInPlanFree: "Everything in plan Free, plus",
    faceAndFinger: "Face and fingerprint",
    rfidBarcode: "RFID, Barcode",
    ipCamera: "IP Camera",
    breakHours: "Break hours",
    locationRestriction: "Location restrictions",
    registrationInformationKiosk: "Registration/Information Kiosk",
    accessControl: "Access Control",
    reportsCustomization: "Reports customization",
    ultimatePersonalDevices: "Unlimited personal devices",
    unlimitedDevicePergroup: "Unlimited devices per group",
    customReportCalculation: "Custom report calculations",
    importExportData: "Import/Export data",
    faceFigerprintIris: "Face, fingerprint, Iris",
    safetyHatDetection: "Safety hat detection (PPE)",
    rfidBarCodeLicensePlate: "RFID, Barcode, License plate",
    visitorQueue: "Visitor queue",
    visitorNote: "Visitor notes",
    upTo3000Visits: "Up to 3000 visits",
    badgeReceiptPrinting: "Badge/receipt printing",
    notifications: "Notifications",
    customFeatureExtensions: "Custom feature extensions",
    biometicDeuplication: "Biometric deduplication and re-enrollment",
    checkidFacialSenseAdminAppIsForEmployeesAdministrationAndAttendanceManagementAvailableForWindowsAndAndroidNoteThatAPaidLicenseIsRequiredToUseIt:
      "The CheckID FacialSense Admin app is for employees administration and attendance management, available for Windows and Android. Note that a paid license is required to use it.",
    checkidFacialSenseAppIsAFreeOnlineToolForPersonalAndGroupAttendanceTrackingIsAvailableForWindowsAndroidIOSOperatingSystems:
      "CheckID FacialSense app is a free online tool for personal and group attendance tracking. Is available for Windows, Android, iOS operating systems.",
    pricesDoNotIncludeLocalImportDutiesOrTaxes:
      "Prices do not include local import duties or taxes.",
    adminApplication: "Admin application",
    singleDeviceInstallation: "Single device installation",
    requestALicense: "Request a license",
    theCheckidFacialSenseAdminAppSimplifiesEmployee:
      "The CheckID FacialSense Admin app simplifies employee enrollment and attendance tracking, turning your phone or tablet into a shared time kiosk. It works online or offline, syncing data to the cloud when internet is available. Event creation, device registration, and automatic clock-ins are supported. Contact us for a license.",
    supportFaceFingerprintIris: "Supports face, fingerprint, iris",
    automaticFaceDetectionAndCapture: "Automatic face detection and capture",
    faceLivenessDetection: "Face liveness detection",
    recognizeAllPersonsFromGroupPhoto: "Recognize all persons from group photo",
    geoFenceTracking: "Geo fence tracking (Location restriction)",
    gpsLocationLogging: "GPS location logging",
    offlineAttendanceLoging: "Offline attendance logging",
    standlonePperation: "Standalone operation",
    kioskMode: "Kiosk mode (hands-free operation)",
    attendApplication: "Attendance application",
    unlimitedInstallation: "Unlimited installations",
    free: "Free",
    downloadApp: "Download app",
    theCheckidFacialSenseAppIsaFreeOInlineTool: "The CheckID FacialSense app is a free online tool for personal and group attendance tracking. It requires an internet connection for check-ins, ensuring real-time cloud syncing and immediate data access on the control panel. The app doesn’t support automatic face capture and operates without needing a license.\n\n",
    supportsFace: "Supports face",
    onlineAttendanceLogging: "Online attendance logging",
    licenseFor1Divices: "license for 1 device",
    titlepage:"Pricing | CheckID FacialSense Service"
  },
  aboutus: {
    header: "About Us",
    customsolutions: "Custom solutions",
    makesure: "Make sure to leave us a message and we will be sure to get back to you as soon as possible.",
    contactus: "Contact us",
    overtheyears: "Over the years we have developed and improved numerous proprietary technologies that are being used in more than 140 countries around the world.",
    byfocus:"By focusing on research and development, Mobile-ID quickly takes advantage of the emerging opportunities that come with the new waves of deep learning technologies.",
    established: "Established in 2016, Mobile-ID is the pioneer of biometric systems development in Vietnam.",
    itwasfound:"It was founded with the key idea of using neural networks for applications covering biometric person identification, robotics, and artificial intelligence fields.",
    ourjourney: "Our journey started with the release of our first biometrics product - a fingerprint identification system for criminal investigations.",
    checkidfacielsensesystem: "CheckID FacialSense systems are smart attendance management solutions developed by Mobile-ID in 2024.",
    baseon:"Based on reliable award-winning algorithms, our products offer advanced attendance monitoring by using face, fingerprint, and iris recognition.",
    checkidfacielsensebio: "CheckID FacialSense Bio Attendance and Visitor Management systems deliver a full package of features, including but not limited to contactless and offline attendance recording, human resource management, report generation, and full control over user attendance.",
    althoughit: "Although its use cases cover education, healthcare, construction, and agriculture industries, the most popular application remains office space, especially now that working from home has become the new normal.",
    wheatheryou: "Whether you are eager to learn about CheckID FacialSense biometric employee attendance and visitor management features, start using our software or have any questions regarding its usage – we are here for you. Contact us now for any inquiries.",
    checkidfacialsensebiometric: "CheckID FacialSense Biometric Systems",
    titlepage:"About Us | CheckID FacialSense Service"
  },
  contactus: {
    header: "Contact Us",
    getin: "Get in",
    touch: "Touch",
    name: "Name",
    email: "Email",
    company: "Company",
    phone: "Phone",
    subject: "Subject",
    message: "Message",
    sendmessage: "Send Message",
    contactinformation: "Contact Information",
    location: "Level 9, Thuy Loi 4 Building, 286-288 Nguyen Xi Street, Binh Loi Trung Ward, Ho Chi Minh City",
    enteryourname: "Enter Your Name",
    enteryouremail: "Enter Your Email",
    enteryourcompany: "Enter Your Company",
    enteryourphoneno: "Enter Your Phone No",
    enteryoursubject: "Enter Your Subject",
    enteryourmessage: "Enter Your Message",
    emailsuccess:"Email send successfully!",
    emailerror:"Fail to send Email!",
    sending:"Sending...",
    validname: "Please enter your name",
    validemail: "Please enter your email",
    validmessage: "Please enter your message",
    required: "Required",
    invalidphone: "Invalid phone number",
    invalidemail: "Invalid email address",
    titlepage:"Contact Us | CheckID FacialSense Service"
  },
  registerasadistributor: {
    header: "Register as a distributor",
    description: "If you want to become a distributor, please fill the form below. We will reply to your request within one or two business days.",
    name: "Name",
    email: "Email",
    company: "Company",
    phone: "Phone",
    subject: "Subject",
    message: "Message",
    sendmessage: "Send Message",
    contactinformation: "Contact Information",
    location: "Level 9, Thuy Loi 4 Building, 286-288 Nguyen Xi Street, Binh Loi Trung Ward, Ho Chi Minh City",
    enteryourname: "Enter Your Name",
    enteryouremail: "Enter Your Email",
    enteryourcompany: "Enter Your Company",
    enteryourphoneno: "Enter Your Phone No",
    enteryoursubject: "Enter Your Subject",
    enteryourmessage: "Enter Your Message",
    emailsuccess:"Email send successfully!",
    emailerror:"Fail to send Email!",
    sending:"Sending...",
    required: "Required",
    invalidphone: "Invalid phone number",
    invalidemail: "Invalid email address",
    titlepage:"Register As A Distributor | CheckID FacialSense Service"
  },
  footer: {
    description:
      "CheckID FacialSense products stand out in the market as multi biometric solutions creating accurate and flexible system applications. Our systems are powered by industry-leading algorithms developed by Mobile-ID.",
    contact: {
      us: "Contact Us",
      address:
        "  Level 9, Thuy Loi 4 Building, 286-288 Nguyen Xi Street, Binh Loi Trung Ward, Ho Chi Minh City",
      phone: " 1900 6884/n +84 28 3622 2982",
      emailName: "info@mobile-id.vn",
    },
    legal: {
      infomation: "Legal information",
      term: "Terms and conditions",
      elements: "Elements",
      data: "Data transfer agreement",
    },
  },
  backtotop: "Back To Top",
  cookies: {
    title: "This website uses cookies",
    description: "By clicking 'Accept all', you agree to the storing of cookies on your device to enhance site navigation, analyze site usage, and assist in our marketing efforts.",
    preferences: "Cookie preferences",
    rejectAll: "Reject all",
    acceptAll: "Accept all",

    preferencesTitle: "Custom Cookie Preferences",
    strictlyNecessary: "Strictly Necessary",
    strictlyNecessaryDesc: "These cookies are required for the website to function properly. They do not collect data for advertising purposes and cannot be disabled, as this would break the site's basic functionality.",
    alwaysActive: "Always Active",

    functional: "Functional / Preferences",
    functionalDesc: "These cookies remember your choices and settings to provide a more personalized experience, such as your selected language, dark/light theme, font size, region, or other customizations.",

    analytics: "Analytics / Performance",
    analyticsDesc: "These cookies help us understand how visitors interact with the site. All data is fully anonymized and used solely to improve site performance, loading speed, and content quality—no personal identification.",

    marketing: "Marketing / Advertising",
    marketingDesc: "These cookies enable us to show you more relevant ads on our site and across other platforms. They anonymously track your browsing behavior and prevent the same ad from appearing repeatedly.",

    savePreferences: "Save preferences",
    cancel: "Cancel"
  }
};
